// SidebarMenu.js

import React, { useEffect, useState } from "react";
import { gql } from "@apollo/client";
import { client } from "../../../client";

import styled from "styled-components";
import AWS from "aws-sdk";

import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Box,
} from "@mui/material";
import FileUploader from "../admin-document/FileUploader";
import { Textarea } from "@mui/joy";
import { useNavigate } from "react-router-dom";

import { uploadFileWithPresignedUrl } from "../../../utils/s3Uploader";

const StyledFormContainer = styled.div`
  max-width: 400px;
  margin: 0 auto;
`;

const CREATE_NOTICE_ADMIN = gql`
  mutation createdNoticeByAdmin(
    $user_id: Int
    $visible: Boolean
    $title: String
    $importance: Importance
    $content: String
    $object_url: String
  ) {
    createdNoticeByAdmin(
      user_id: $user_id
      visible: $visible
      title: $title
      importance: $importance
      content: $content
      object_url: $object_url
    ) {
      message
    }
  }
`;

const CreateNoticeAdmin = () => {
  useEffect(() => {}, []);

  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const token = localStorage.getItem("accessToken")?.replace("Bearer ", "");

  const base64Payload = token.split(".")[1];

  const base64 = base64Payload.replace(/-/g, "+").replace(/_/g, "/");

  const decodedJWT = JSON.parse(
    decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    )
  );

  const userId = decodedJWT.id;

  const [formData, setFormData] = useState({
    visible: true,
    title: "",
    content: "",
    importance: "GENERAL",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (objectUrlString) => {
    client
      .mutate({
        mutation: CREATE_NOTICE_ADMIN,
        variables: {
          user_id: userId,
          visible: formData.visible,
          title: formData.title,
          content: formData.content,
          importance: formData.importance,
          object_url: objectUrlString,
        },
        fetchPolicy: "no-cache",
      })
      .then((res) => {
        window.alert("공지사항이 등록되었습니다.");
        navigate("/admin/notice");
      })
      .catch((err) => {
        window.alert(`등록 중 오류가 발생했습니다: ${err.message}`);
        console.error(err);
      });
  };

  const handleUploadAndSubmit = async () => {
    if (!formData.title) {
      alert("제목을 입력해주세요.");
      return;
    }

    setIsLoading(true);
    try {
      let finalObjectUrl = null;
      if (selectedFile) {
        finalObjectUrl = await uploadFileWithPresignedUrl(client, selectedFile);
      }
      handleSubmit(finalObjectUrl);
    } catch (err) {
      alert(`업로드 중 오류가 발생했습니다: ${err.message}`);
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <h2>공지사항 등록</h2>
      <StyledFormContainer>
        <form>
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <InputLabel id="visible">노출</InputLabel>
            <Select
              labelId="visible"
              id="visible"
              name="visible"
              value={formData.visible}
              label="visible"
              onChange={handleChange}
            >
              <MenuItem value={true}>노출</MenuItem>
              <MenuItem value={false}>비노출</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <TextField
              label="제목"
              name="title"
              defaultValue={formData.title}
              onChange={handleChange}
              sx={{ marginBottom: 2 }}
            ></TextField>
          </FormControl>

          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <Textarea
              id="content"
              name="content"
              placeholder="내용을 입력해주세요"
              onChange={handleChange}
              sx={{ marginBottom: 2, height: "250px" }}
            ></Textarea>
          </FormControl>

          <FileUploader
            selectedFiles={selectedFile ? [selectedFile] : []}
            setSelectedFiles={(files) => setSelectedFile(files[0] || null)}
          />

          <Button
            variant="contained"
            onClick={handleUploadAndSubmit}
            disabled={isLoading}
            sx={{ mt: 2 }}
          >
            {isLoading ? "등록 중..." : "공지사항 등록"}
          </Button>
        </form>
      </StyledFormContainer>
    </div>
  );
};

export default CreateNoticeAdmin;
